module.exports = __webpack_public_path__ + "static/media/Jake Beyer.00bd964d.png";